<template>
  <div class="layout-segment">
    <h3 class="font-22 mb-32">{{ getSectionTitle() }}</h3>
    <T1GTabs tabLabelType="h4">
      <template v-if="!getDomainType('travelone', 'skione')">
        <T1GTabsContent key="0" :title="getTitle(0)" renderContent>
          <div class="guide-content mb-8" v-html="mainOpis"></div>
          <div class="forecast-addon mb-24">
            <div class="font-m font-20 mb-18">Pogoda na najbliższe dni</div>
            <T1ForecastHomePageGuide
              :wname="tabTitle"
              :locid="locid"
              v-if="locid"
            />
          </div>
        </T1GTabsContent>
      </template>
      <T1GTabsContent
        v-for="(item, index) in opisy"
        :key="`${index + 1}`"
        :title="getTitle(index + 1)"
        renderContent
      >
        <div class="guide-content mb-8" v-html="item"></div>
      </T1GTabsContent>

      <template v-if="getDomainType('travelone', 'skione')">
        <T1GTabsContent :key="`${opisy.length + 1}`" title="Pogoda">
          <T1Forecasts :locid="locid" />
        </T1GTabsContent>
      </template>
    </T1GTabs>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import T1GTabs from "./T1Tabs/T1GTabs";
import T1GTabsContent from "./T1Tabs/T1GTabsContent";
import T1ForecastHomePageGuide from "./T1PogodaKlimat/T1ForecastHomePageGuide";
import T1Forecasts from "./T1PogodaKlimat/T1Forecasts";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  name: "przewodnik-front",
  mixins: [domainTypeMixin],
  data: () => ({
    mainOpis: "",
    opisy: [],
    locid: CONFIG.locid,
    tabTitle: CONFIG.panstwo_nazwa,
    titles: [],
  }),
  methods: {
    getSectionTitle() {
      if (this.getDomainType("travelone", "skione")) {
        return "Niezbędnik turystyczny";
      } else {
        return "Przewodnik";
      }
    },
    getTitle(index) {
      if (index == 0) {
        return this.tabTitle;
      } else {
        return this.titles[index - 1];
      }
    },
    getTitle2(index) {
      if (index == 0) {
        return this.tabTitle;
      } else {
        return this.titles2[index - 1];
      }
    },
    async readMainOpis() {
      let URL = "/xml/" + this.locid + ".xml";
      let text = await fetch(URL);
      //awaits for text.text() prop
      //and then sends it to parseMainOpis()
      this.parseMainOpis(await text.text());
    },
    async readOpisy() {
      let opisFileSuffix = "-opis.xml";
      if (this.getDomainType("travelone", "skione")) {
        opisFileSuffix = ".xml";
      }

      let URL = "/xml/" + this.locid + opisFileSuffix;
      let text = await fetch(URL);
      this.parseOpisy(await text.text());
    },
    parseMainOpis(text) {
      let xmlDoc = jQuery.parseXML(text);
      let xmlObj = jQuery(xmlDoc);
      let that = this;
      xmlObj.find("Lead").each(function () {
        jQuery(this)
          .find("link")
          .each(function () {
            let link = jQuery(this).attr("to");
            let linkTxt = jQuery(this).html();
            jQuery(this).replaceWith(
              '<a href="' +
                that.replaceLinkWithRelative(link) +
                '">' +
                linkTxt +
                "</a>"
            );
          });
        that.mainOpis = jQuery(this).html();
      });
    },
    parseOpisy(text) {
      let xmlDoc = jQuery.parseXML(text);
      let xmlObj = jQuery(xmlDoc);
      let that = this;
      xmlObj.find("Sekcja").each(function (index, element) {
        jQuery(this)
          .find("link")
          .each(function () {
            let link = jQuery(this).attr("to");
            let linkTxt = jQuery(this).html();
            jQuery(this).replaceWith(
              '<a href="' +
                that.replaceLinkWithRelative(link) +
                '">' +
                linkTxt +
                "</a>"
            );
          });
        let title = jQuery(this).attr("tytul");
        if (typeof title !== "undefined" && title !== "") {
          that.opisy.push(jQuery(this).html());
          that.titles.push(title);
        }
      });
    },
    replaceLinkWithRelative(link) {
      if (
        link != "" &&
        link.indexOf("www.") !== -1 &&
        link.indexOf(".pl/") !== -1
      ) {
        let index = link.indexOf(".pl/");
        if (index > 0) {
          return link.substring(index + 3);
        } else {
          return link;
        }
      } else {
        return link;
      }
    },
  },
  mounted() {
    if (!this.getDomainType("travelone", "skione")) {
      this.readMainOpis();
    }
    this.readOpisy();
  },
  components: {
    T1GTabs,
    T1GTabsContent,
    T1ForecastHomePageGuide,
    T1Forecasts,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .guide-content {
  ul {
    list-style-type: none;
    padding-left: 24px;

    > li {
      position: relative;
      margin-bottom: 4px;

      &::before {
        content: "";
        display: block;
        background-color: $blue-dark;
        border-radius: 2px;
        position: absolute;
        left: -18px;
        top: 7px;
        width: 6px;
        height: 6px;
      }
    }
  }
}
</style>
